import React, { useState, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
} from "reactstrap";
import Header from "../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import moment from "moment";

function ReportePL() {
  const { user } = useContext(AuthContext);
  const URL_GRAFICAS = process.env.REACT_APP_URL_GRAFICAS;

  let hoy = moment(new Date()).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("2021-01-01");
  const [selectedFechaFin, setSelectedFechaFin] = useState(hoy);

  const [pl, setPl] = useState([]);

  useMemo(() => {
    axios
      .get(`${URL_GRAFICAS}/pl/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setPl(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const moneda = (valor) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      roundingIncrement: 5,
    }).format(valor);

  const porcentaje = (valor) =>
    valor === null || valor === undefined
      ? "NA"
      : `${valor.toFixed(2)}%`;

  function PDFTabla() {
    const dataPDF = pl.map((c) => [
      c.Año,
      moneda(c.Venta),
      porcentaje(c.IncrementoVenta),
      moneda(c.PromedioVentaMensual),
      moneda(c.Gasto),
      porcentaje(c.IncrementoGasto),
      moneda(c.Utilidad),
      porcentaje(c.IncrementoUtilidad),
    ]);

    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text("P&L", 20, 25);
    doc.autoTable({
      head: [
        [
          "Año",
          "Venta",
          "% Inc. Venta",
          "Prom. Venta Mensual",
          "Gasto",
          "% Inc. Gasto",
          "Utilidad",
          "% Inc. Utilidad",
        ],
      ],
      body: dataPDF,
      startY: 45,
    });
    doc.save("PL.pdf");
  }

  function excel() {
    const dataExcel = pl.map((c) => {
      return {
        Año: c.Año,
        Venta: c.Venta,
        IncrementoVenta: c.IncrementoVenta,
        PromedioVentaMensual: c.PromedioVentaMensual,
        Gasto: c.Gasto,
        IncrementoGasto: c.IncrementoGasto,
        Utilidad: c.Utilidad,
        IncrementoUtilidad: c.IncrementoUtilidad,
      };
    });

    var option = {};

    option.fileName = `PL-${selectedFechaInicio}-${selectedFechaFin}`;

    option.datas = [
      {
        sheetData: dataExcel,
        sheetName: `PL`,
        sheetFilter: [
          "Año",
          "Venta",
          "IncrementoVenta",
          "PromedioVentaMensual",
          "Gasto",
          "IncrementoGasto",
          "Utilidad",
          "IncrementoUtilidad",
        ],
        sheetHeader: [
          "Año",
          "Venta",
          "% Inc. Venta",
          "Prom. Venta Mensual",
          "Gasto",
          "% Inc. Gasto",
          "Utilidad",
          "% Inc. Utilidad",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  let totalVenta = 0;
  let totalGasto = 0;
  let totalUtilidad = 0;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.usuarios_permisos ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                    <Button
                      size="sm"
                      href="/MenuReportes"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                  <Col md={5}>
                    <ButtonGroup id="logoutBoton">
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={PDFTabla}
                      >
                        PDF <i class="far fa-file-pdf"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={excel}
                      >
                        Excel <i class="far fa-file-excel"></i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
                <br />
                <h3 align="center">P&L</h3>
                <Row>
                  <Col md={2}>
                    <Label>Fecha Inicio</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaInicio}
                      onChange={(e) => {
                        setSelectedFechaInicio(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Fecha Fin</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaFin}
                      onChange={(e) => {
                        setSelectedFechaFin(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <br />
                <Table
                  size="sm"
                  striped
                  borderless
                  className="table-responsive-xl"
                >
                  <thead>
                    <tr>
                      <th className="negrita">Año</th>
                      <th className="negrita">Venta</th>
                      <th className="negrita">% Inc. Venta</th>
                      <th className="negrita">Prom. Venta Mensual</th>
                      <th className="negrita">Gasto</th>
                      <th className="negrita">% Inc. Gasto</th>
                      <th className="negrita">Utilidad</th>
                      <th className="negrita">% Inc. Utilidad</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pl.map((c) => {
                      totalVenta = totalVenta + c.Venta;
                      totalGasto = totalGasto + c.Gasto;
                      totalUtilidad = totalUtilidad + c.Utilidad;
                      return (
                        <tr>
                          <td>{c.Año}</td>
                          <td>{moneda(c.Venta)}</td>
                          <td
                            style={{
                              color:
                                c.IncrementoVenta === null
                                  ? "inherit"
                                  : c.IncrementoVenta >= 0
                                  ? "green"
                                  : "red",
                            }}
                          >
                            {porcentaje(c.IncrementoVenta)}
                          </td>
                          <td>{moneda(c.PromedioVentaMensual)}</td>
                          <td>{moneda(c.Gasto)}</td>
                          <td
                            style={{
                              color:
                                c.IncrementoGasto === null
                                  ? "inherit"
                                  : c.IncrementoGasto <= 0
                                  ? "green"
                                  : "red",
                            }}
                          >
                            {porcentaje(c.IncrementoGasto)}
                          </td>
                          <td>{moneda(c.Utilidad)}</td>
                          <td
                            style={{
                              color:
                                c.IncrementoUtilidad === null
                                  ? "inherit"
                                  : c.IncrementoUtilidad >= 0
                                  ? "green"
                                  : "red",
                            }}
                          >
                            {porcentaje(c.IncrementoUtilidad)}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td className="negrita">TOTAL</td>
                      <td className="negrita">{moneda(totalVenta)}</td>
                      <td></td>
                      <td></td>
                      <td className="negrita">{moneda(totalGasto)}</td>
                      <td></td>
                      <td className="negrita">{moneda(totalUtilidad)}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default ReportePL;
